<template>
  <div id="page-Campaign-edit">
    <vx-card v-if="campaign">
      <div slot="no-body" class="px-6 pt-6">
        <div class="vx-row">
          <div class="vx-col w-full"><h2>Kampagne erstellen</h2></div>
        </div>
        <ValidationObserver ref="CampaignForm" tag="form">
          <CampaignGeneral v-model="campaign" />
        </ValidationObserver>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="text-right mt-3 pb-3">
              <vs-button @click="createCampaign">Erstellen</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import CampaignGeneral from "../form/CampaignGeneral";

export default {
  components: {
    CampaignGeneral
  },
  data() {
    return {
      campaign: {}
    };
  },
  methods: {
    async createCampaign() {
      let result = await this.$refs.CampaignForm.validate();
      if (result) {
        let { data } = await this.$apollo.mutate({
          mutation: gql`
            mutation($input: CreateAdCampaignInput!) {
              createAdCampaign(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: {
              ...this.campaign
            }
          }
        });

        if (data.createAdCampaign.id) {
          this.$router.push({
            name: "bi.campaigns.edit",
            params: { id: data.createAdCampaign.id }
          });
        } else {
          this.$vs.notify({
            title: "Fehlgeschlagen",
            text: "Eingabe ist fehlgeschlagen.",
            color: "danger",
            icon: "query_builder",
            position: "bottom-center"
          });
          document.documentElement.scrollTop = 0;
        }
      }
    }
  }
};
</script>
